import founder from "../../../Assets/Img/founder.webp"

const FounderData =[
  
    {
        Imgfounder: founder,
        heading: "Alwin Ng",
        text: "Co-Founder"
    },
    {
        Imgfounder: founder,
        heading: "Alwin Ng",
        text: "Co-Founder"
    },
    {
        Imgfounder: founder,
        heading: "Alwin Ng",
        text: "Co-Founder"
    },
    {
        Imgfounder: founder,
        heading: "Alwin Ng",
        text: "Co-Founder"
    },
    {
        Imgfounder: founder,
        heading: "Alwin Ng",
        text: "Co-Founder"
    },
    {
        Imgfounder: founder,
        heading: "Alwin Ng",
        text: "Co-Founder"
    },
    {
        Imgfounder: founder,
        heading: "Alwin Ng",
        text: "Co-Founder"
    },
    {
        Imgfounder: founder,
        heading: "Alwin Ng",
        text: "Co-Founder"
    }
  
]
export default FounderData;